import {
  AllJudgments,
  CivilExplosivesJudgmentData,
  ProfessionalDriverJudgmentData,
} from "./types";
import dayjs from "dayjs";

export const commonJudgmentDeafults = (judgment: AllJudgments) => {
  return {
    firstName: judgment?.firstName || "",
    lastName: judgment?.lastName || "",
    pesel: judgment?.pesel || "",
    documentType: judgment?.documentType || "",
    documentNumber: judgment?.documentNumber || "",
    country: judgment?.country || "",
    address: judgment?.address || "",
    city: judgment?.city || "",
    postalCode: judgment?.postalCode || "",
    issueDate: judgment?.issueDate || judgment?.completionDate,
    completionDate: judgment?.completionDate || dayjs().toISOString(),
    sex: judgment?.sex || "",
  };
};

export const hasNextExaminationField = (
  obj: AllJudgments
): obj is ProfessionalDriverJudgmentData => {
  if (Object.prototype.hasOwnProperty.call(obj, "nextExamination")) {
    return true;
  }

  return false;
};

export const hasAppealDeadlineField = (
  obj: AllJudgments
): obj is CivilExplosivesJudgmentData => {
  if (Object.prototype.hasOwnProperty.call(obj, "appealDeadline")) {
    return true;
  }

  return false;
};

/**
 * Oblicza datę następnego badania na podstawie wieku badanego w dniu wykonania badania
 * @param birthDate - data urodzenia badanego
 * @param completionDate - data wykonania aktualnego badania
 * @returns ISO string z datą następnego badania lub pusty string jeśli brak danych
 */
export const calculateNextExaminationDate = (
  birthDate?: string,
  completionDate?: string
): string => {
  if (!birthDate || !completionDate) {
    return "";
  }

  const birthDateObj = dayjs(birthDate);
  const examinationDate = dayjs(completionDate);

  // Oblicz dokładny wiek w dniach wykonania badania
  const totalAgeInDays = examinationDate.diff(birthDateObj, "day");
  const criticalAge57and6monthsInDays = 57 * 365.25 + 6 * 30.44; // 57 lat i 6 miesięcy w dniach (uwzględniając lata przestępne)
  const age60InDays = 60 * 365.25; // 60 lat w dniach (uwzględniając lata przestępne)

  if (totalAgeInDays <= criticalAge57and6monthsInDays) {
    // Jeśli wiek <= 57 lat i 6 miesięcy, dodaj 5 lat
    return examinationDate.add(5, "year").subtract(1, "day").toISOString();
  } else if (totalAgeInDays < age60InDays) {
    // Jeśli wiek > 57 lat i 6 miesięcy ale < 60 lat
    // Data następnego badania = 5 lat pomniejszone o różnicę między aktualnym wiekiem a 57 lat i 6 miesięcy
    const daysDifference = totalAgeInDays - criticalAge57and6monthsInDays;

    return examinationDate
      .add(5, "year")
      .subtract(daysDifference, "day")
      .subtract(1, "day")
      .toISOString();
  }

  // Jeśli wiek >= 60 lat, dodaj 30 miesięcy
  return examinationDate.add(30, "month").subtract(1, "day").toISOString();
};